import { Injectable } from "@angular/core";
import {
  AngularFirestoreCollection,
  AngularFirestore,
  DocumentReference,
} from "@angular/fire/firestore/";
import { Ticket, TicketRecord } from "src/app/interfaces/support";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import firebase, { firestore, storage } from "firebase/app";

import "firebase/storage";

@Injectable({
  providedIn: "root",
})
export class TicketsService {
  defaultReplies = [
    {
      name: "Solicitar domicilio",
      reply:
        "¡Hola [USUARIO]! Te pedimos una disculpa por el inconveniente. Por favor compártenos desde cual fraccionamiento te comunicas para dar de alta tu domicilio en el sistema a la brevedad. Estaremos pendientes de tu respuesta ¡Que tengas un excelente día!",
    },
    {
      name: "Comunícate con tu administrador",
      reply:
        "¡Hola [USUARIO]! En este caso te pedimos que te comuniques con tu administrador residencial para recibir más información acerca del problema. Si necesitas mayor asistencia por favor comunícate con nosotros nuevamente. Lamentamos las molestias",
    },
    {
      name: "Comunícate con atención a clientes",
      reply:
        "¡Hola [USUARIO]! En este caso te pedimos que te pongas en contacto con el equipo de atención a clientes llamando a cualquiera de estos teléfonos Culiacán (667) 753 6632 o Mazatlán (669) 990 6411 para recibir mejor asistencia. Si tienes alguna duda extra no dudes en contactarnos nuevamente. Lamentamos las molestias",
    },
    {
      name: "Existe falla en equipos",
      reply:
        "¡Hola [USUARIO]! Actualmente se están presentando [FALLA] con los equipos instalados en tu residencial. Esta falla ya fue reportada y estamos trabajando para solucionarla [TIEMPO ESTIMADO]. Agradecemos tu paciencia y nos disculpamos por el inconveniente",
    },
    {
      name: "Falla de internet en privada",
      reply:
        "Hola [USUARIO], los equipos de tu privada están fuera de línea debido a una falla en el servicio de internet. Por el momento aparecen en señal gris. Estamos a la espera de que se restablezca la conexión. Agradecemos tu paciencia y comprensión.",
    },
    {
      name: "Mantenimiento en equipos",
      reply:
        "Hola [USUARIO], estamos realizando mantenimiento a los equipos de tu privada. El equipo de soporte técnico ya se encuentra trabajando para resolverlo lo antes posible.  Agradecemos tu paciencia y nos disculpamos por el inconveniente.",
    },
    {
      name: "Existe falla en la app",
      reply:
        "¡Hola [USUARIO]! En estos momentos estamos realizando mejoras en el servicio y esperamos que este se reactive en [TIEMPO ESTIMADO]. Si continúas experimentando problemas por favor responde este mensaje para brindarte más asistencia. Lamentamos el inconveniente",
    },
    {
      name: "Seguimiento de problema",
      reply:
        "Hola [USUARIO], gracias por compartirnos tu problema. Queremos informarte que nuestro equipo ya está trabajando para solucionarlo lo antes posible. Agradecemos tu paciencia y pronto te daremos una actualización.",
    },
    {
      name: "Cuenta duplicada",
      reply:
        "Buen día [USUARIO], detectamos que tienes dos cuentas: una con ----- y otra con -----. La suscripción está activa en la primera, por lo que debes iniciar sesión con esa. Por favor marca esta solicitud como resuelta.",
    },
    {
      name: "Solicitud resuelta",
      reply:
        "¡Hola [USUARIO]! Hemos [PROBLEMA RESUELTO], si hay alguna otra cosa en la que podamos asistirte por favor responde este mensaje, de lo contrario te pedimos que marques esta solicitud como resuelta. ¡Saludos!",
    },
    {
      name: "Domicilio vinculado",
      reply:
        "Ya hemos vinculado tu domicilio a tu cuenta. Si aún no cuentas con una suscripción activa, puedes adquirirla directamente desde tu aplicación. Solo selecciona la opción “Adquirir suscripción” y sigue los pasos para completar el proceso. Si necesitas apoyo durante el pago, estamos aquí para ayudarte. ¡Gracias por utilizar nuestro servicio!",
    },
  ];

  private ticketsCollection: AngularFirestoreCollection<Ticket>;
  private tickets: Observable<Ticket[]>;
  public ticketsData: Ticket[] = [];
  public ticket: Ticket;
  types: string[] = [];
  limit = 50;
  constructor(private afs: AngularFirestore) {
    this.ticketsCollection = this.afs.collection<Ticket>(
      "support_tickets",
      (ref) => {
        return ref
          .where("status", "==", "open")
          .orderBy("title", "asc")
          .orderBy("ts", "asc");
      }
    );
    this.tickets = this.ticketsCollection.snapshotChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data() as Ticket;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

  getTickets(): Observable<Ticket[]> {
    return this.tickets;
  }

  getTicketByUser(userRef: DocumentReference) {
    const ticketsCollection = this.afs.collection<Ticket>(
      "support_tickets",
      (ref) => {
        return ref
          .where("userRef", "==", userRef)
          .orderBy("ts", "desc")
          .limit(1);
      }
    );

    return ticketsCollection.valueChanges();
  }

  getOpenTicketByUser(userRef: DocumentReference) {
    const ticketsCollection = this.afs.collection<Ticket>(
      "support_tickets",
      (ref) => {
        return ref
          .where("userRef", "==", userRef)
          .where("status", "==", "open")
          .orderBy("ts", "desc")
          .limit(1);
      }
    );

    return ticketsCollection.valueChanges();
  }

  getTicketById(id: string) {
    const ticketsCollection = this.afs.collection<Ticket>(
      "support_tickets",
      (ref) => {
        return ref.where("id", "==", id).limit(1);
      }
    );

    return ticketsCollection.valueChanges();
  }

  getRecordByAgent(agent: string, limit: number): Observable<any> {
    const agentRef = this.afs.collection("users").doc(agent).ref;
    const ticketsCollection = this.afs
      .collection<Ticket>("support_tickets")
      .doc("activity")
      .collection("records", (ref) => {
        return ref
          .where("agentRef", "==", agentRef)
          .orderBy("ts", "desc")
          .limit(limit);
      });
    return ticketsCollection.valueChanges();
  }

  getRecordBySystem(limit: number): Observable<any> {
    const ticketsCollection = this.afs
      .collection<Ticket>("support_tickets")
      .doc("activity")
      .collection("records", (ref) => {
        return ref
          .where("agentName", "==", "system")
          .orderBy("ts", "desc")
          .limit(limit);
      });
    return ticketsCollection.valueChanges();
  }

  reportOnTicketTypeByAgent(
    start: Date,
    final: Date,
    types: string[],
    agent: string,
    limit?: number
  ): Observable<any[]> {
    limit ? (this.limit = limit) : "";
    const agentRef = this.afs.collection("users").doc(agent).ref;
    let ticketsCollection: AngularFirestoreCollection<Ticket>;
    ticketsCollection = this.afs
      .collection<Ticket>("support_tickets")
      .doc("activity")
      .collection("records", (ref) => {
        return ref
          .where("ts", ">=", new Date(start))
          .where("ts", "<=", new Date(final))
          .where("action", "in", types)
          .where("agentRef", "==", agentRef)
          .orderBy("ts", "desc")
          .limit(this.limit);
      });
    return ticketsCollection.valueChanges();
  }

  reportOnTicketType(
    start: Date,
    final: Date,
    types: string[],
    limit?: number
  ): Observable<any[]> {
    limit ? (this.limit = limit) : "";
    let ticketsCollection: AngularFirestoreCollection<Ticket>;
    ticketsCollection = this.afs
      .collection<Ticket>("support_tickets")
      .doc("activity")
      .collection("records", (ref) => {
        return ref
          .where("ts", ">=", new Date(start))
          .where("ts", "<=", new Date(final))
          .where("action", "in", types)
          .orderBy("ts", "desc")
          .limit(this.limit);
      });
    return ticketsCollection.valueChanges();
  }

  reportOnTickets(start: Date, final: Date, limit?: number): Observable<any[]> {
    limit ? (this.limit = limit) : "";
    let ticketsCollection: AngularFirestoreCollection<Ticket>;
    ticketsCollection = this.afs
      .collection<Ticket>("support_tickets")
      .doc("activity")
      .collection("records", (ref) => {
        return ref
          .where("ts", ">=", new Date(start))
          .where("ts", "<=", new Date(final))
          .orderBy("ts", "desc")
          .limit(this.limit);
      });
    return ticketsCollection.valueChanges();
  }

  closeTicket(ticket: Ticket) {
    const ticketRef = this.afs.firestore
      .collection("support_tickets")
      .doc(ticket.id);
    ticketRef
      .set(
        {
          status: ticket.status,
        },
        { merge: true }
      )
      .then((t) => {
        let i = 0;
        ticket.chat.forEach((chat) => {
          chat.imgUrl ? i++ : null;
        });
        const storageRef = firebase.storage().ref();
        while (i > 0) {
          storageRef
            .child("public/support/" + this.ticket.id + "/" + i + ".png")
            .delete();
          i--;
        }
      })
      .catch(() => {});
    this.ticket = null;
  }

  addTicket(ticket: Ticket) {
    return new Promise((resolve, reject) => {
      this.ticketsCollection
        .add(ticket)
        .then((obj: any) => {
          const a = this.afs.firestore
            .collection("support_tickets")
            .doc(obj.id);
          a.update({
            id: obj.id,
          });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  addTicketRecord(record: TicketRecord) {
    return new Promise((resolve, reject) => {
      this.ticketsCollection
        .doc("activity")
        .collection("records")
        .add(record)
        .then((obj: any) => {
          const a = this.afs.firestore
            .collection("support_tickets")
            .doc("activity")
            .collection("records")
            .doc(obj.id);
          a.update({
            id: obj.id,
          });
          resolve(obj);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  updateTicket(ticket: Ticket): Promise<void> {
    return this.ticketsCollection.doc(ticket.id).set(ticket, { merge: true });
  }
}
